import React from "react";
import { Button } from "../Button/Button";
import { TwentyIcArrowLineLeft } from "../icons/TwentyIcArrowLineLeft";
import { TwentyIcEdit } from "../icons/TwentyIcEdit";
import "./TopBar.css";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";

export const TopBar = ({
  icon,
  hasDate,
  hasEdit,
  title,
  breadcrumbText,
  onClick,
  filters,
  filtersExist,
  removeFilter,
}) => {

  const navigate = useNavigate();

  const date = new Date().toString();

  const nameMonth = [
    t("month.january"),
    t("month.february"),
    t("month.march"),
    t("month.april"),
    t("month.may"),
    t("month.june"),
    t("month.july"),
    t("month.august"),
    t("month.september"),
    t("month.october"),
    t("month.november"),
    t("month.december"),
  ];

  function getNameMonth(mese) {
    return nameMonth[mese];
  }

  function formattaData(dataString) {
    const data = new Date(dataString);

    const day = data.getDate();
    const month = data.getMonth();
    const year = data.getFullYear();

    const nomeMese = getNameMonth(month);

    return `${day} ${nomeMese} ${year}`;
  }
 

 

  return (
    <div className="top-bar">
      <div className="top-bar-left-container">
        {breadcrumbText && (
          <div className="top-bar-breadcrumb" onClick={onClick}>
            {breadcrumbText}
          </div>
        )}
        <div className="top-bar-icon-title-container">
          {breadcrumbText ? (
            <div className="top-bar-icon-breadcrumb">
              <div className="botton-go-back">
                <Button
                  icon={<TwentyIcArrowLineLeft color="#000" />}
                  className="button-instance"
                  size="m"
                  style={{ iconLine: true }}
                  onClick={() => {
                    console.log("Filtri prima della rimozione:", filters);

                    if (filtersExist) {
                      console.log("Filtri da rimuovere:", filters);
                      removeFilter(
                        filters,
                        filters.entries().next().value?.[1]
                      );
                    } else {
                      console.log("Non ci sono filtri da rimuovere.");
                      navigate(-1);
                    }
                  }}
                />
              </div>
            </div>
          ) : (
            icon && (
              <div className="top-bar-icon">{React.cloneElement(icon)}</div>
            )
          )}
          <div className="top-bar-title">{title}</div>
          {hasEdit && <TwentyIcEdit color="#000" />}
        </div>
      </div>
      {hasDate && <div className="top-bar-date">{formattaData(date)}</div>}
    </div>
  );
};
